/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slot_OneInputs */

const en_slot_one = /** @type {(inputs: Slot_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slot`)
};

const de_slot_one = /** @type {(inputs: Slot_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platz`)
};

/**
* | output |
* | --- |
* | "slot" |
*
* @param {Slot_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_one = /** @type {((inputs?: Slot_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_one(inputs)
	return en_slot_one(inputs)
});